export function setButtonLoading(button, loading) {
  if (loading) {
    button.setAttribute("data-loading", "");
    button.setAttribute("disabled", "");
  } else {
    button.removeAttribute("data-loading");
    button.removeAttribute("disabled");
  }
}
